import { getCashSummary } from '../../cash/domain-api';
import { getSalesComparison, getSalesByTimeBand, getSalesSnapshotByDateRangeWithVentasScope, getTodaySalesSnapshot } from '../../sales/public-api';
import { getIntelligenceKpis } from '../infra/intelligenceKpisRepo';
import {
  fetchRemoteBranchCashSessions,
  fetchRemoteBranchCashSummary,
  fetchRemotePosExceptionSummary,
  fetchRemoteSalesComparison,
  fetchRemoteSalesDaily,
  fetchRemoteSalesByCashier,
  fetchRemoteSalesSnapshot,
  fetchRemoteSalesTimeBands,
  fetchWithRetry,
} from '../infra/reportsRemoteRepo';
import {
  loadReportsOperacionDashboardCore,
  loadReportsOperacionRentabilidadKpis,
  type LoadReportsOperacionDashboardParams,
  type LoadReportsOperacionDashboardResult,
  type LoadReportsOperacionRentabilidadParams,
  type LoadReportsOperacionRentabilidadResult,
  type ReportsOperacionDashboardDeps,
} from './reportsOperacionDashboardCore';

export type {
  LoadReportsOperacionDashboardParams,
  LoadReportsOperacionDashboardResult,
  LoadReportsOperacionRentabilidadParams,
  LoadReportsOperacionRentabilidadResult,
} from './reportsOperacionDashboardCore';

export { loadReportsOperacionRentabilidadKpis };

/** Implementación por defecto (app / React Native). */
export const defaultReportsOperacionDashboardDeps: ReportsOperacionDashboardDeps = {
  getCashSummary,
  getSalesSnapshotByDateRangeWithVentasScope,
  getTodaySalesSnapshot,
  getSalesComparison,
  getSalesByTimeBand,
  fetchWithRetry,
  fetchRemoteBranchCashSummary,
  fetchRemoteSalesSnapshot,
  fetchRemoteSalesComparison,
  fetchRemoteSalesTimeBands,
  fetchRemoteSalesDaily,
  fetchRemoteSalesByCashier,
  fetchRemoteBranchCashSessions,
  fetchRemotePosExceptionSummary,
  getIntelligenceKpis,
};

/**
 * Caso de uso: KPIs Informes > Operación con prioridad remota y fallback SQLite local.
 */
export async function loadReportsOperacionDashboard(
  params: LoadReportsOperacionDashboardParams
): Promise<LoadReportsOperacionDashboardResult> {
  return loadReportsOperacionDashboardCore(params, defaultReportsOperacionDashboardDeps);
}

export async function loadReportsOperacionRentabilidad(
  params: LoadReportsOperacionRentabilidadParams
): Promise<LoadReportsOperacionRentabilidadResult> {
  return loadReportsOperacionRentabilidadKpis(params, defaultReportsOperacionDashboardDeps);
}
